import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=36879980&scoped=true&"
var script = {}
import style0 from "./banner.vue?vue&type=style&index=0&id=36879980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36879980",
  null
  
)

export default component.exports